import { useQuery } from 'react-query';
import { customerBusinessService } from '../../services';

const getDevices = async () => {
    const response = await customerBusinessService.authenticatedDevicesList();
    return response.data.data;
};

export default function useGetAuthenticatedDevices(
) {
    return useQuery('authDevices', () => getDevices(), {
        retry: false,
        staleTime: 0,
        cacheTime: 0
    });
}
